import { type SVGProps } from "react";

export const OutlineClub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6733 8.93536C14.9917 8.1013 16.0346 3.28325 16.5861 1H19.5069C18.6539 6.36778 17.0632 17.0531 16.8395 17.9046C16.6017 18.8093 16.0307 19.7806 15.6505 20.231C15.214 20.7479 14.1771 21.6369 12.1351 22.273C10.5584 22.7641 8.62487 22.945 7.02229 22.9967C5.41971 23.0484 4.61842 22.4798 4.12731 22.0145C3.63619 21.5492 1.59417 18.7576 1.1806 17.9822C0.767034 17.2067 1.15935 16.496 1.40816 16.0694C1.83033 15.3457 3.13998 14.3615 5.36799 13.5363C6.76379 13.0194 9.71047 12.5024 11.2614 12.0888C12.8122 11.6753 14.022 10.6413 14.6733 8.93536Z"
      stroke="#6D777C"
    />
    <path d="M6.63867 15.3008V20.8008" stroke="#6D777C" />
    <path d="M9.9386 14.2012L12.6886 19.7012" stroke="#6D777C" />
    <path
      d="M8.26148 14.6466C5.89489 15.1162 4.91638 15.699 4.14446 16.2826C3.77722 16.5603 3.58947 16.9019 3.53906 17.2423C3.4913 17.5648 3.57123 17.8579 3.689 18.0542C3.80176 18.2421 4.09276 18.7068 4.40718 19.1807C4.72111 19.654 5.05982 20.1387 5.26754 20.3653C5.68291 20.8184 6.13745 21.0841 6.63109 21.141C7.12057 21.1975 8.49251 21.2726 10.1275 20.9343C11.7618 20.5962 13.2523 19.9562 13.9319 18.4838C14.6107 17.013 14.4035 15.6903 13.7023 15.0269L13.3587 15.3902L13.7023 15.0269C13.5137 14.8486 13.2389 14.7131 12.9236 14.6127C12.5987 14.5093 12.1917 14.4307 11.7035 14.3906C10.7608 14.313 9.57675 14.3835 8.26183 14.6465L8.26148 14.6466Z"
      stroke="#6D777C"
    />
  </svg>
  // <svg
  //   fill="#000000"
  //   version="1.1"
  //   id="Capa_1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   xmlnsXlink="http://www.w3.org/1999/xlink"
  //   width="30"
  //   height="30"
  //   viewBox="0 0 532.843 532.843"
  //   xmlSpace="preserve"
  // >
  //   <g>
  //     <g>
  //       <path
  //         d="M396.532,135.845c9.333,3.155,23.906-4.313,25.676-20.272c1.08-9.725-1.913-19.221-11.36-22.252l-37.639-3.51
  // 		c-13.109-3.892-27.138,3.519-31.298,16.562l-34.808,93.598l-17.729,4.141L282.93,33.957c0.144-13.693-10.863-25.121-24.528-25.522
  // 		L221.557,0c-9.917-0.077-15.73,8.013-17.748,17.585c-3.318,15.711,8.186,27.358,18.044,27.282L262.054,47l6.474,161.989
  // 		l-28.754,6.722L190.919,84.332c-4.16-13.043-18.178-20.455-31.298-16.562l-37.628,3.509c-9.438,3.041-12.431,12.527-11.36,22.252
  // 		c1.769,15.96,16.342,23.428,25.675,20.272l38.852-10.557l43.901,117.303l-6.062,1.415c-12.976,0-23.792,9.094-26.526,21.257
  // 		c-12.775,3.414-55.769,21.879-49.113,114.387c4.15,57.604,27.884,90.251,48.405,107.961v40.038
  // 		c0,15.042,12.192,27.234,27.234,27.234h116.51c15.042,0,27.233-12.183,27.233-27.234v-4.542h24.7
  // 		c10.031,0,18.149-8.128,18.149-18.149V380.311c0-10.03-8.128-18.149-18.149-18.149h-24.7v-65.293h7.373
  // 		c10.021,0,18.149-8.138,18.149-18.149v-45.384c0-10.031-8.138-18.15-18.149-18.15h-8.329
  // 		c-2.859-11.063-12.46-19.335-24.174-20.244l26.058-69.625L396.532,135.845z M185.784,424.528
  // 		c-10.222-15.559-19.01-37.696-21.257-68.869c-3.978-55.271,11.293-75.219,21.257-82.344V424.528z"
  //       />
  //     </g>
  //   </g>
  // </svg>
);
